var map = {
	"./dev.env": "dhIU",
	"./prod.env": "rBKV",
	"./test.env": "WXia"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HHk6";


//////////////////
// WEBPACK FOOTER
// ./config ^\.\/.*\.env$
// module id = HHk6
// module chunks = 5